export default [
  {
    path: '/satchel/management',
    name: 'managementSatchel',
    component: () => import('@/pages/satchel/ManagementSatchelPage.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_management_satchel_menu',
    },
  },
  {
    path: '/satchel/sell_management',
    name: 'sellSatchel',
    component: () => import('@/pages/satchel/SellSatchelPage.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_sell_satchel_menu',
    },
  },
  {
    path: '/satchel/accountant_management',
    name: 'accountantSatchel',
    component: () => import('@/pages/satchel/AccountantSatchelPage.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_accountant_satchel_menu',
    },
  },
  {
    path: '/satchel/buy_management',
    name: 'buySatchel',
    component: () => import('@/pages/satchel/BuySatchelPage.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_buy_satchel_menu',
    },
  },
  {
    path: '/satchel/installer_management',
    name: 'installerSatchel',
    component: () => import('@/pages/satchel/InstallerSatchelPage.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_installer_satchel_menu',
    },
  },
  {
    path: '/satchel/product_management',
    name: 'productSatchel',
    component: () => import('@/pages/satchel/ProductSatchelPage.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_product_satchel_menu',
    },
  },
  {
    path: '/satchel/product_export',
    name: 'productExportSatchel',
    component: () => import('@/pages/satchel/ExportProject.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_product_export_menu',
    },
  },
]
